import React from "react";
import {StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import {
    FormLabel, getInputClassNames, getInputWrapperClass, getWholeDivWrapperClass,
} from "../../sharedStyles.tsx";
import {defaultParserForSelects} from "../../../dyanimcFormUtil.tsx";



const StaticSelectDescriptionRenderer: React.FC<StaticFieldDisplayProps> = ({ component, value, controller }) => {
    const parsedValue = defaultParserForSelects(value);
    value = parsedValue && parsedValue?.label ? parsedValue.label : value;
    const description = (component?.match as Record<string, string>)?.[value] ?? "-";
    return (
        <div className={getWholeDivWrapperClass(component)}>
            <FormLabel component={component}></FormLabel>
            <div className={getInputWrapperClass(component)}>
                        <span className={getInputClassNames(component, controller.fieldState)}>
                            {description}
                        </span>
            </div>
        </div>
    );
};
export const StaticSelectDescription = React.memo(StaticSelectDescriptionRenderer);